export default "__VITE_ASSET__b610893f__"